import * as prismic from '@prismicio/client'

export const client = prismic.createClient('nomiswap')
